export default __webpack_public_path__ + "static/media/447.d6b1d085.gif";